import { MaskedEmail } from '@flipster/react/design-utils/masking';
import CircleNoticeLineIcon from '@flipster/ui/assets/svgs/circle-notice-line.svg';

import styles from './verifyEmail.module.scss';

interface Props {
  email: string;
}

const VerifyEmail = ({ email }: Props) => {
  return (
    <div className={styles.wrapper}>
      <header>
        <h1>Check your email</h1>
      </header>
      <p className={styles.pageDesc} translate='yes'>
        Flipster requires verification to process security measures. Click on the link to get started.
      </p>

      <div className={styles.verifyEmailWrapper}>
        <MaskedEmail email={email} />
      </div>

      <div className={styles.infoNotice}>
        <span className={styles.infoIcon}>
          <CircleNoticeLineIcon />
        </span>
        <p translate='yes'>Please confirm your email in 24 hours, or sign up will be canceled.</p>
      </div>
    </div>
  );
};

export default VerifyEmail;
